// extracted by mini-css-extract-plugin
export default {"container":"EmptyState_container__TIx9x","title":"EmptyState_title__oOigp","subtitle":"EmptyState_subtitle__60wkw"};